export default __webpack_public_path__ + "static/media/user2.68ec5114.png";